import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import {
  ServicesSubSectionContainer,
  ServicesSubSectionHeader,
  ServicesSubSectionRow,
  ServicesSubSectionMainContent,
  ServicesSubSectionTitle,
  ServicesSubSectionValue,
} from '../../services/services-subsection/services-subsection.styles';
import { useStore } from '../../../stores/store';
import {
  getLengthConfig,
  getWeightConfig,
} from '../parcel-details-dimensions/dimensionsConfig';
import { ShipmentTypeToTranslationMap } from '../parcel-details-dimensions/helpers';

const ParcelDetailsSummary = () => {
  const {
    userStore: { measures },
    parcelCreationStore: { shipment, isDocumentShipmentType },
  } = useStore();

  const { t } = useTranslation();

  if (!shipment) return;

  const { parcel, sender, recipient, shipment_type: shipmentType } = shipment;

  const weightConfig = getWeightConfig(measures);
  const lengthConfig = getLengthConfig(measures);

  const parcelWeight = `${parcel?.weight} ${t(weightConfig.suffix)}`;
  const parcelDimensions = `${parcel?.size_z} x ${parcel?.size_x} x ${parcel?.size_y} ${t(lengthConfig.suffix)}`;
  const fromAddress = `${sender?.country_name}, ${sender?.address.post_code}, ${sender?.address.city}`;
  const toAddress = `${recipient?.country_name}, ${recipient?.address.post_code}, ${recipient?.address.city}`;

  const sizeBlock = (
    <>
      <ServicesSubSectionRow>
        <ServicesSubSectionTitle>{t('weight')}</ServicesSubSectionTitle>
        <ServicesSubSectionValue>{parcelWeight}</ServicesSubSectionValue>
      </ServicesSubSectionRow>
      <ServicesSubSectionRow>
        <ServicesSubSectionTitle>{t('dimensions')}</ServicesSubSectionTitle>
        <ServicesSubSectionValue>{parcelDimensions}</ServicesSubSectionValue>
      </ServicesSubSectionRow>
    </>
  );

  const typeBlock = (
    <ServicesSubSectionRow>
      <ServicesSubSectionTitle>{t('shipment_type')}</ServicesSubSectionTitle>
      <ServicesSubSectionValue>
        {t(ShipmentTypeToTranslationMap[shipmentType].transKey)}
      </ServicesSubSectionValue>
    </ServicesSubSectionRow>
  );

  const showSizes = !isDocumentShipmentType;
  const showType = isDocumentShipmentType;

  return (
    <ServicesSubSectionContainer>
      <ServicesSubSectionHeader>{t('parcel_details')}</ServicesSubSectionHeader>
      <ServicesSubSectionMainContent>
        <ServicesSubSectionRow>
          <ServicesSubSectionTitle>{t('from')}</ServicesSubSectionTitle>
          <ServicesSubSectionValue>{fromAddress}</ServicesSubSectionValue>
        </ServicesSubSectionRow>
        <ServicesSubSectionRow>
          <ServicesSubSectionTitle>{t('to')}</ServicesSubSectionTitle>
          <ServicesSubSectionValue>{toAddress}</ServicesSubSectionValue>
        </ServicesSubSectionRow>
        {showSizes && sizeBlock}
        {showType && typeBlock}
      </ServicesSubSectionMainContent>
    </ServicesSubSectionContainer>
  );
};

export default observer(ParcelDetailsSummary);
